import React from 'react'
import { cn } from '../../lib/utils'
import { 
    FormMessage, 
    FormLabel, 
    FormControl, 
    FormItem 
} from '../ui/form'

export interface InputGroupProps {
    label?: React.ReactNode;
    rightIcon?: React.ReactNode;
    leftIcon?: React.ReactNode;
    wrapperClassName?: string;
    labelClassName?: string;
    /** Inline style for label (used so workscope colors always apply) */
    labelStyle?: React.CSSProperties;
    error?: string;
    isDirty?: boolean;
    /** When true, show yellow background when value is empty (e.g. required fields on Profile) */
    highlightWhenEmpty?: boolean;
}

interface FormTextInputWrapperProps {
    inputGroupProps?: InputGroupProps;
    children: React.ReactNode;
    /** Reserve vertical space for validation text so paired fields don’t shift when errors appear */
    reserveMessageSlot?: boolean;
}

function FormTextInputWrapper({
    inputGroupProps,
    children,
    reserveMessageSlot,
}: FormTextInputWrapperProps) {
    return (
        <FormItem className={cn(
            "space-y-0.5 w-full",
            inputGroupProps?.wrapperClassName,
        )}>
            {
                inputGroupProps?.label &&
                    <FormLabel
                        className={cn(
                            "form-label transition-colors duration-200",
                            inputGroupProps.isDirty && "text-[#9c27b0]",
                            !inputGroupProps.labelClassName && !inputGroupProps.labelStyle && "text-foreground",
                        )}
                        style={typeof inputGroupProps.label === "string" && inputGroupProps.labelStyle ? inputGroupProps.labelStyle : undefined}
                    >
                        {typeof inputGroupProps.label === "string" && inputGroupProps.labelClassName ? (
                            <span className={cn(inputGroupProps.isDirty && "text-[#9c27b0]", inputGroupProps.labelClassName)}>
                                {inputGroupProps.label}
                            </span>
                        ) : (
                            inputGroupProps.label
                        )}
                    </FormLabel>
            }
            <FormControl>
                <div className='relative flex items-center w-full'>
                    {/* Left Icon */}
                    {inputGroupProps?.leftIcon && (
                        <div className={cn(
                            "form-input-icon",
                            "left-4",
                        )}>
                            {inputGroupProps.leftIcon}
                        </div>
                    )}
                    
                    {/* Input */}
                    {children}

                    {/* Right Icon Button */}
                    {inputGroupProps?.rightIcon && (
                        <div className={cn(
                            "form-input-icon",
                            "right-4",
                        )}>
                            {inputGroupProps.rightIcon}
                        </div>
                    )}
                </div>
            </FormControl>
            {reserveMessageSlot ? (
                <div className="mt-1 min-h-[2.5rem]">
                    {inputGroupProps?.error ? (
                        <div className="text-sm text-destructive">{inputGroupProps.error}</div>
                    ) : (
                        <FormMessage />
                    )}
                </div>
            ) : inputGroupProps?.error ? (
                <div className="text-sm text-destructive mt-1">
                    {inputGroupProps.error}
                </div>
            ) : (
                <FormMessage />
            )}
        </FormItem>
    )
}

export default FormTextInputWrapper